module.exports = __webpack_public_path__ + "img/05.f011af0a.jpg";